import { CardListFieldsFragment } from "@src/generated/graphql";
import { highlightBracketedText, highlightUnderscoreText } from "src/utils/utils";
import DynamicMedia from "src/components/shared/DynamicMedia"

type SuperChargingProps = {
  content: CardListFieldsFragment;
};

const SuperCharging = ({ content }) => {
  const { title, cardsCollection, description, linkText } = content;
  const items = cardsCollection?.items ?? [];

  if (!content) return null;

  return (
    <div className="features-section">
      <div className="container-fluid custom-spacer-col features-space">
        <div className="feature-inner">
          <div className="features-heading">
            <span
              className="highlight-bracket-text"
              dangerouslySetInnerHTML={{
                __html: highlightBracketedText(title ?? "", "bold"),
              }}
              style={{ textAlign: "center", fontSize: "3.5rem" }}
            />
            <p className="features-description product-inner-description text-center">
              {description}
            </p>
          </div>
          <div className="features-inner-section">
            {items.map((item, index) => {
              const listItems =
                item?.cardDescription?.json?.content
                  ?.filter((val) => val.nodeType === "unordered-list")[0]
                  ?.content?.map(
                    (item) => item?.content[0]?.content[0]?.value
                  ) || [];

              return (
                <div key={item.sys.id} className="feature-box">
                  <div className="features-inner-image">
                    <DynamicMedia
                      src={item?.cardImage?.url ?? ""}
                      alt={item?.cardImage?.title  ?? ""}
                      ariaLabel={item?.cardImage?.title  ?? ""}
                      lottieProps={{
                        loop: true,
                        style: {
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          transform: "unset",
                        },
                      }}
                      lottieClassName="feature-lottie"
                    />
                  </div>
                  <div className="feature-inner-content">
                    {item?.cardIcon?.url && (
                      <div className="feature-inner-icon">
                        <img src={item?.cardIcon?.url ?? ""} alt={item?.cardIcon?.title ?? ""} />
                      </div>
                    )}

                    <div className="feature-head">
                      <h3
                       dangerouslySetInnerHTML={{
                         __html: highlightBracketedText(item?.cardEyebrowText ?? "", "bold"),
                       }}
                      />
                      <p
                       dangerouslySetInnerHTML={{
                        __html: highlightUnderscoreText(item?.cardTitle ?? ""),
                      }}
                     />
                    </div>
                    <ul className="feature-list">
                      {listItems.map((listItem, i) => (
                        <li key={i}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M16.909 8.72725L10.3635 15.2727L7.63628 12.5454M16.909 8.72725L10.3635 15.2727M22.909 12C22.909 18.0249 18.0248 22.9091 11.9999 22.9091C5.97499 22.9091 1.09082 18.0249 1.09082 12C1.09082 5.97505 5.97499 1.09088 11.9999 1.09088C18.0248 1.09088 22.909 5.97505 22.909 12Z"
                              stroke="#8773DA"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              fill="#CDCDF3"
                            />
                            <path
                              d="M16.909 8.72729L10.3635 15.2727L7.63623 12.5455"
                              stroke="#8773DA"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                          <span className="font-medium">{listItem}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <div className="feature-btn">
          <a href="#" target="_blank" className="btn-white">
            <span>See Gradial in action</span>
            <svg
              stroke="currentColor"
              fill="currentColor"
              strokeWidth="0"
              viewBox="0 0 512 512"
              className="btn-icon"
              height="1em"
              width="1em"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l370.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z" />
            </svg>
          </a>
        </div>
      </div>
    </div>
  );
};

export default SuperCharging;
